import { Component, Input, Output, EventEmitter } from '@angular/core';
import { LucideAngularModule } from 'lucide-angular';

export type NotifFilter = 'all' | 'read' | 'unread' | 'mentioned';

interface FilterOption {
  value: NotifFilter;
  label: string;
  icon: string;
}

@Component({
  selector: 'app-notifications-filter-dropdown',
  standalone: true,
  imports: [LucideAngularModule],
  templateUrl: './notifications-filter-dropdown.component.html',
  styleUrls: ['./notifications-filter-dropdown.component.scss'],
})
export class NotificationsFilterDropdownComponent {
  @Input() activeFilter: NotifFilter = 'all';
  @Output() filterChange = new EventEmitter<NotifFilter>();

  readonly options: FilterOption[] = [
    { value: 'read',      label: 'Read',                  icon: 'check-circle' },
    { value: 'unread',    label: 'Unread',                icon: 'eye'          },
    { value: 'mentioned', label: 'Mentioned Me',          icon: 'at-sign'      },
    { value: 'all',       label: 'All Workspace Updates', icon: 'clock'        },
  ];

  select(value: NotifFilter): void {
    this.filterChange.emit(value);
  }
}
